module.exports = __webpack_public_path__ + "static/media/empty-sensogram.6db05a18.png";